import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {  useNavigate } from 'react-router-dom';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { init } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, register,login} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const St = (props) => {
    const { t } = useTranslation()


    const navigate = useNavigate()//hook事件路由跳转
    
    

     const go = (url)=>{
        if(url =="no"){
             message.error(t('g.暂未开放'))
           return
        }
           
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
            navigate(url,{
                state:{
                    address:props.address
                }
            })
        }



    useEffect(() => {
        // window.scrollTo(0, 0)
           
           
    }, 
    // eslint-disable-next-line
    [props.isLogin]);

    return (
        <>
            <Head/>
            

            
            
            <div style={{"backgroundColor":"#18120A"}} className=' stbg  w-full lg:w-1/3 min-h-screen px-4 pt-32 text-white flex flex-col'>
                <div onClick={()=>go("/game")} className=' w-full h-6 mx-auto mt-24  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题1')}</span>
                </div>
                <div onClick={()=>go("/game")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/1.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("/game")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍1')}
                </div>


                <div onClick={()=>go("/nft")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题7')}</span>
                </div>
                <div onClick={()=>go("/nft")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/7.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("/nft")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍7')}
                </div>

                <div onClick={()=>go("/staking")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题2')}</span>
                </div>
                <div onClick={()=>go("/staking")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/2.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("/staking")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍2')}
                </div>


                <div onClick={()=>go("/box")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题3')}</span>
                </div>
                <div onClick={()=>go("/box")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/3.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("/box")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍3')}
                </div>

                <div onClick={()=>go("/pool")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题11')}</span>
                </div>
                <div onClick={()=>go("/pool")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/11.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("/pool")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍11')}
                </div>


                <div onClick={()=>go("no")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题4')}</span>
                </div>
                <div onClick={()=>go("no")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/4.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("no")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍4')}
                </div>


                <div onClick={()=>go("no")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题5')}</span>
                </div>
                <div onClick={()=>go("no")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/5.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("no")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍5')}
                </div>


                <div onClick={()=>go("no")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题6')}</span>
                </div>
                <div onClick={()=>go("no")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/6.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("no")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍6')}
                </div>


                


                <div onClick={()=>go("no")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题8')}</span>
                </div>
                <div onClick={()=>go("no")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/8.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("no")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍8')}
                </div>


                <div onClick={()=>go("no")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题9')}</span>
                </div>
                <div onClick={()=>go("no")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/9.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("no")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍9')}
                </div>


                <div onClick={()=>go("no")} className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <span className=' text-base text-text-act'>{t('st.生态标题10')}</span>
                </div>
                <div onClick={()=>go("no")} className="w-full mt-4  flex flex-row justify-center items-center ">  
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/st/10.png')} style={{"width":"100%"}}></img>
                </div>
                <div onClick={()=>go("no")} className="w-full h-24 mt-3  px-4 text-xs text-gray-200 py-4 break-words flex flex-row justify-start items-center  stTitle">
                   {t('st.生态介绍10')}
                </div>

                
            </div>
            

                <div className=' w-full h-32 ' style={{"backgroundColor":"#18120A"}}></div>
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(St);
